<div class="modal-header bg-light border-light c-custom-modal-header--wrapper">
    <div class="modal-title pull-left">
        <h3 class="mb-0 font-weight-bold">Select Companies</h3>
        <small class="text-muted font-weight-bold"></small>
    </div>

    <button type="button" id="compny-modal-close" (click)="bsModalRef.hide()"
        class="close pull-right align-self-center" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-light">
    <div class="select-company-content--wrapper">
        <div class="select-company-content--box">
            <h4 class="select-company-content--boxTitle">Select the companies for which you want to generate reports.</h4>
            <div class="form-group">
                <input type="text" class="input input__large input__blue" placeholder="Search...">
            </div>

            <div class="select-company-user-search-group--wrapper">
                <ul class="select-company-user-search-group--list custom__scroll pl-0">
                    <li class="select-company-user--item" *ngFor="let cmpny of companyList; let i = index">
                        <label class="checkbox m-0">
                            <input type="radio" class="checkbox__input" [value]="false">
                            <div class="checkbox__data p-0">
                                <div class="checkbox__indicator"></div>
                                <p class="checkbox__text font-size-16__imp">
                                    {{cmpny.name}}
                                </p>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" id="compny-modal-cancel" class="button secondary__button large__button"
        (click)="decline()">Cancel</button>
    <button type="button" id="compny-modal-continue" class="button primary__button large__button"
        (click)="confirm()">Select companies</button>
</div>